module.exports = __webpack_public_path__ + "img/flamethrower-fire-stream-spine.a0343fc3.png";